export default __webpack_public_path__ + "static/media/taami-mikra-mission.d7bd9823.jpg";